import React from 'react';
import { TextField } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { phoneRegex } from '@thd-olt-functional/utils';
import constants from '../../constants/constants';

const unformatPhone = (textParam) => {
  let text = textParam;
  if (!text) {
    text = '';
  }
  return text.replace(/\D/g, '');
};

export const phoneValidator = (formattedPhoneNumber) => {
  let phoneNumber = unformatPhone(formattedPhoneNumber);
  return phoneRegex.test(phoneNumber)
    && !phoneNumber.startsWith('0')
    && !phoneNumber.startsWith('1');
};

export const formatPhone = (val) => {
  if (!val) {
    return '';
  }

  let format = unformatPhone(val).match(/(.{0,3})(.{0,3})(.{0,4})/);
  return !format[2] ? format[1] : '(' + format[1] + ') ' + format[2] + (format[3] ? '-' + format[3] : '');
};

export function PhoneFieldFormatter({ callback, value, name }) {

  const handleChange = (event) => {
    let phoneNumber = unformatPhone(event.target.value);
    if (phoneNumber.startsWith('0') || phoneNumber.startsWith('1')) {
      phoneNumber = phoneNumber.slice(1);
    }
    if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.slice(0, -1);
    }

    callback(phoneNumber);
  };

  const isInvalid = value && !phoneValidator(value);

  return (
    <TextField
      name={`phone-${name}`}
      data-testid="phone-input"
      label="Phone Number"
      type="phone"
      value={formatPhone(value)}
      placeholder="(___)___-____"
      onChange={handleChange}
      status={isInvalid ? 'error' : undefined}
      statusMessage={isInvalid ? constants.PHONE_FIELD_VALIDATOR_ERROR_TEXT : undefined}
      fullWidth
    />
  );
}

PhoneFieldFormatter.propTypes = {
  callback: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string
};

PhoneFieldFormatter.defaultProps = {
  name: 'phone-input'
};
